var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: _vm.title,
        size: "lg",
        "hide-close": "",
        "hide-actions": ""
      }
    },
    [
      _c("div", { staticClass: "characteristic-completion-check" }, [
        _c(
          "div",
          { staticClass: "characteristic-completion-check--content" },
          [_c("div", [_c("Jon")], 1), _vm._v(" "), _vm._t("info")],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "characteristic-completion-check--actions" },
          [
            _c("Button", {
              staticClass: "mr-2",
              attrs: { text: _vm.okButtonText, secondary: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("ok")
                }
              }
            }),
            _vm._v(" "),
            _c("Button", {
              attrs: { text: "Jetzt eingeben", icon: "pencil" },
              on: {
                click: function($event) {
                  return _vm.$emit("abort")
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "characteristic-completion-check--cancel" }, [
          _c(
            "a",
            {
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.$emit("skip")
                }
              }
            },
            [_vm._v("Später eingeben")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }